/** @format */
import { Heading as HeadingComponent } from '@mpb-com/feather/components/atoms/heading';
import styled from 'styled-components';

import { theme } from '@toucan/client/global/theme';

// eslint-disable-next-line @mpb-com/mpb/no-exported-styled-component, @mpb-com/mpb/styled-component-prefix -- Legacy code: do not use as an example.
export const MarketSelectorModalWrapper = styled.div`
    display: flex;
    flex-direction: column;

    max-height: 53rem;
    overflow: hidden;
`;

// eslint-disable-next-line @mpb-com/mpb/no-exported-styled-component, @mpb-com/mpb/single-styled-component, @mpb-com/mpb/styled-component-prefix -- Legacy code: do not use as an example.
export const Heading = styled(HeadingComponent)`
    align-self: center;
    margin-bottom: var(--layout-spacing-12);
`;

// eslint-disable-next-line @mpb-com/mpb/no-exported-styled-component, @mpb-com/mpb/single-styled-component, @mpb-com/mpb/styled-component-prefix -- Legacy code: do not use as an example.
/* eslint-disable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
// eslint-disable-next-line @mpb-com/mpb/no-exported-styled-component, @mpb-com/mpb/single-styled-component, @mpb-com/mpb/styled-component-prefix -- Legacy code: do not use as an example.
export const Selected = styled.section`
    margin-bottom: var(--layout-spacing-12);

    p {
        ${theme.typography.body_small_highlight};
        margin-bottom: var(--layout-spacing-4);
    }
`;
/* eslint-enable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */

// eslint-disable-next-line @mpb-com/mpb/no-exported-styled-component, @mpb-com/mpb/single-styled-component, @mpb-com/mpb/styled-component-prefix -- Legacy code: do not use as an example.
export const Selectable = styled.section`
    overflow-y: scroll;
`;
